import React, { Component } from 'react';
import { Grid, Row, Col, Panel } from 'react-bootstrap';
import Radium from 'radium';

import filter_img from '../../../images/filter.png';
import Utils from '../../../lib/utils';
import { Minus, Plus } from "../../Jobs/Filters/style.ts";
import { styles, PageTitle, Filters, Header, SubMenu } from "./Common/filterStyles";



class ProfileFilter extends Component {

  state = {
    selected: [
      { id: 0, expanded: false },
      { id: 1, expanded: false },
      { id: 2, expanded: false },
      { id: 3, expanded: false },
    ],
    filters: {
      city_in: [],
      country_in: [],
      employment_type_in: [],
      state_in: [],
      title: [],
    }
  };

  componentWillMount() {
    this.initFilters()
  }

  componentWillReceiveProps() {
    this.initFilters()
  }

  formatHeader(str) {
    return str.toLowerCase().replace(' ', '-');
  }

  initFilters() {
    var filters = this.props.filters;
    var checkboxes = Array.from(document.getElementsByTagName('Input'));
    checkboxes.forEach(cb => {
      for (var attrs in filters) {
        if (filters[attrs][0] === cb.value) {
          cb.checked = true;
        }
      }
    })
  }

  toggle = (_, e) => {
    let selected = this.state.selected;
    let newItem = {
      id: e,
      expanded: this.state.selected[e]
        ? !this.state.selected[e].expanded
        : true,
    };

    selected.filter((item) => item.id !== e);

    this.setState({
      selected: selected
        .filter((item) => item.id !== e)
        .concat(newItem)
        .sort((a, b) => a.id - b.id),
    });
  };

  filterResults = (e) => {
    let currentFilters = this.state.filters[e.target.name] || [];
    if (e.target.checked) {
      currentFilters = currentFilters.concat(e.target.value);
    } else {
      currentFilters = currentFilters.filter(
        (filter) => filter !== e.target.value
      );
    }

    this.setState(
      {
        filters: {
          ...this.state.filters,
          [e.target.name]: currentFilters,
        },
      },
      () => {
        this.persistFilters(this.state.filters);
        this.props.search(this.state.filters);
      }
    );
  }

  persistFilters(filters) {
    filters = Utils.clean(filters);
    localStorage.setItem("ProfileFilters", JSON.stringify(filters));
  }

  filters() {
      var filters = [{
        header: 'Title',
        values: this.props.filters ? this.props.filters.titles: [],
        link: '/profiles/search/#',
      },
      {
        header: 'City',
        values: this.props.filters ? this.props.filters.cities : [],
        link: '/profiles/search/#',
      },
      {
        header: 'State',
        values: this.props.filters ? this.props.filters.states : [],
        link: '/profiles/search/#',
      },
      {
        header: 'Country',
        values: this.props.filters ? this.props.filters.countries: [],
        link: '/profiles/search/#',
      },
      {
        header: 'Employment Type',
        values: this.props.filters ? this.props.filters.employmentTypes : [],
        link: '/profiles/search/#',
      }];

    return filters.filter(
      (e) => e.values && e.values.values && e.values.values.length > 0
    );
  }

  render() {
    return (
      <Grid
        style={styles.container}
        fluid={true}
        className="hidden-xs"
        id="profiles-filter"
      >
        <Row>
          <Col>
            <PageTitle>
              <img src={filter_img} alt="Filter Results" />
              <span className="title">Filter Results</span>
            </PageTitle>
            <Filters>
              {this.filters().map((filter, i) => {
                const header = filter.header.toLowerCase();
                return (
                <Panel
                  onSelect={(_) => this.toggle(_, i)}
                  collapsible
                  header={
                    <Header>
                      {filter.header}
                      <span>
                        <i className="pull-right" aria-hidden="true">
                          {this.state.selected.find((item) => item.id === i)
                            .expanded ? (
                            <Minus />
                          ) : (
                            <Plus />
                          )}
                        </i>
                      </span>
                    </Header>
                  }
                  key={i}
                  eventKey={i}
                >
                  <SubMenu>
                    {filter.values &&
                      filter.values.values
                        .filter((v) => !!v)
                        .map((v, j) => (
                          <li key={j}>
                            <span className="row">
                              <input
                                className="css-checkbox"
                                id={`${v} - ${j}`}
                                name={`${header !== "title" ? `${header}_in` : header}`}
                                type="checkbox"
                                value={v}
                                onClick={this.filterResults}
                              />
                              <label
                                className="css-label"
                                htmlFor={`${v} - ${j}`}
                                style={{ color: "#999" }}
                              >
                                {v}
                              </label>
                            </span>
                          </li>
                        ))}
                  </SubMenu>
                </Panel>
                )}
              )}
            </Filters>
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default Radium(ProfileFilter);
